export default {
  scorecard: {
    title: 'Thẻ điểm',
    content: 'Nội dung',
    award: 'Giải thưởng ESG',
  },
  list_table_filter: {
    table_buyer_company_name: 'Công ty bên mua',
    table_question_group_name: 'Phiếu câu hỏi',
    table_status: 'Trạng thái',
    table_issue_at: 'Ngày phát hành',
    table_sustaina_rate: 'Xếp hạng ESG',
    table_esg_score: 'Điểm ESG',
    table_operation: 'Vận hành',
    displayed_items_number: 'Hiển thị {start}〜{end} / {total} công ty',
    displayed_items_number_empty: 'Hiển thị 0 / 0 công ty',
    no_data_display: 'Không có dữ liệu',
    csv_modal_title: 'Vui lòng chọn các mục cần xuất trên CSV',
    csv_modal_answer_status_title: 'Trạng thái câu trả lời',
    csv_modal_answer_status_text: 'Xuất danh sách trạng thái câu trả lời của nhà cung cấp.',
    csv_modal_answer_title: 'Câu trả lời (1 tệp cho 500 công ty)',
    csv_modal_answer_title_by_individual_company: 'Câu trả lời (1 tệp cho mỗi công ty)',
    csv_modal_answer_text: 'Câu trả lời của nhà cung cấp sẽ được xuất ra thành 1 tệp cho mỗi 500 công ty.',
    csv_modal_answer_text_by_individual_company: 'Câu trả lời của nhà cung cấp sẽ được xuất ra thành 1 tệp cho mỗi 1 công ty.',
    csv_modal_score_title: 'Điểm',
    csv_modal_score_text: 'Xuất xếp hạng và điểm của nhà cung cấp',
    csv_modal_answer_heading: 'Tiêu đề',
    csv_modal_answer_heading_supplier: 'Nhà cung cấp',
    csv_modal_answer_heading_question: 'Câu hỏi',
    csv_modal_answer_additional: 'Mục bổ sung',
    csv_modal_answer_additional_note: 'Ghi chú',
    csv_modal_answer_additional_file: 'Tên tệp đính kèm',
    csv_modal_cautionary_note_title: 'Chú ý',
    csv_modal_cautionary_note_content: '・Tệp đầu ra bao gồm "trạng thái câu trả lời", "câu trả lời" và "điểm" cho {questionGroupName}.\n・Đối với "trạng thái câu trả lời", tất cả các công ty đã đăng ký đều được đưa vào, bất kể trạng thái câu trả lời của họ trong khảo sát là gì.\n・Đối với "câu trả lời" và "điểm", các công ty có trạng thái câu trả lời là "Đang tiến hành" sẽ không được đưa vào tệp đầu ra.\n・Số lượng công ty tối đa có thể hiển thị trong một tệp CSV cho "câu trả lời" và "điểm" là 1.000.\n・Tệp CSV sẽ được gửi đến địa chỉ email của tài khoản hiện đang đăng nhập.',
    csv_modal_sent_mail_section_one: 'Yêu cầu xuất CSV của bạn đã được chấp nhận.',
    csv_modal_sent_mail_section_two: 'Vui lòng đợi trong giây lát cho đến khi email chứa URL tải xuống CSV sẽ được gửi đến địa chỉ email của bạn.',
    csv_modal_sent_mail_section_three: 'Nếu không nhận được email trong vòng 30 phút, vui lòng thử lại.',
  },
  overall_score_section: {
    card_title: 'Nội dung khảo sát',
    score: 'Điểm',
    esg_score: 'Điểm ESG',
    esg_rating: 'Xếp hạng ESG',
    esg_score_tip: 'Điểm ESG là đánh giá về các hoạt động ESG của công ty bạn. Điểm này được tính dựa trên câu trả lời khảo sát ASUENE ESG của bạn.',
    esg_rating_tip: 'Xếp hạng ESG là đánh giá tuyệt đối về mức độ hoạt động ESG của công ty bạn được phân loại theo thang điểm bảy từ AAA đến CCC dựa trên điểm ESG của bạn.',
    evaluator_advice_title: 'Nhận xét đánh giá',
    list_header_buyer_company_name: 'Công ty bên mua',
    list_header_supplier_company_name: 'Nhà cung cấp',
    list_header_question: '@:common.upload.title',
    list_header_create_at: 'Ngày phát hành',
    list_header_deadline: 'Thời hạn hiệu lực',
    list_header_industry: 'Ngành',
    list_header_company_scale: 'Số lượng nhân viên',
    download_csv: 'Xuất tệp CSV',
    download_pdf: 'Xuất tệp PDF',
    csv_title_for_buyer: 'Các câu trả lời trong phiếu câu hỏi ASUENE ESG',
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Tải xuống câu trả lời dưới dạng csv.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Tải xuống câu trả lời dưới dạng pdf.',
    scorecard_pdf: 'Thẻ điểm(PDF)',
    download_scorecard_pdf_description: 'Tải xuống điểm dưới dạng pdf.',
    feedback: 'Phản hồi đánh giá',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'Tài liệu sẽ được tải xuống dưới dạng PDF.',
    award_medal_svg: 'Giải thưởng ESG(SVG)',
    download_award_medal_svg_description: 'Tải xuống dưới dạng hình ảnh SVG',
    award_medal_png: 'Giải thưởng ESG(PNG)',
    download_award_medal_png_description: 'Tải xuống dưới dạng hình ảnh PNG',
    pdf_modal_sent_mail_section_one: 'Yêu cầu xuất PDF của bạn đã được chấp nhận.',
    pdf_modal_sent_mail_section_two: 'Vui lòng đợi trong giây lát cho đến khi email chứa URL tải xuống PDF sẽ được gửi đến địa chỉ email của bạn.',
    pdf_modal_sent_mail_section_three: 'Nếu không nhận được email trong vòng 30 phút, vui lòng thử lại.',
  },
  category_score_section: {
    card_title: 'Điểm theo danh mục',
    tip: 'Điểm theo danh mục là điểm dành cho danh mục môi trường, xã hội và quản trị của công ty bạn. Trọng số của các câu hỏi trong mỗi danh mục sẽ khác nhau tùy theo công ty.',
    policy: 'Chính sách',
    action: 'Hành động',
    result: 'Kết quả',
  },
  score_by_category_compared_section: {
    card_title: 'So sánh điểm theo danh mục',
    get_score_by_category: 'Điểm theo danh mục của công ty bạn',
    esg_evaluated_all_companies_average: 'Tất cả các công ty đã được ASUENE ESG đánh giá',
    tip: 'Đây là điểm trung bình của các công ty trả lời cùng một khảo sát.',
  },
  strengths_advice_section: {
    card_title: 'Điểm mạnh, lời khuyên',
    strong_point: 'Điểm mạnh',
    advice: 'Điểm cải thiện',
    policies: 'Chính sách',
    action: 'Hành động',
    result: 'Kết quả',
    no_results_for_this_category: 'Không có kết quả nào cho Phân loại này',
    risk: 'Nguy cơ',
    indicator: 'Chỉ số',
    content: 'Nội dung',
    operation: 'Vận hành',
  },
  preview: {
    go_back_to_scorecard: 'Quay lại Bảng điểm',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Tóm tắt tổng điểm',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Điểm trung bình:',
    category_card_score_no_score: 'Không áp dụng',
    category_card_score_earned_score: 'Điểm của bạn',
    category_card_details_list_title: 'Nhận xét đánh giá',
    category_card_details_no_score_tip: 'Danh mục này không được đưa vào đánh giá.',
    category_card_score_average_score: 'Điểm trung bình của tất cả công ty',
    category_card_details_title: 'Tóm tắt điểm danh mục',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: 'Mục này không áp dụng vì khảo sát được đánh giá theo logic của người mua.',
    buyer_evaluate_tip: 'Mục này được đánh giá theo logic của người mua. Không được đánh giá dựa trên logic Chấm điểm của Asuene ESG.',
    answer_rejection_notification: 'Bạn đã nhận được yêu cầu rút lại mới',
    answer_rejection_modal_title: 'Gửi lại bài nộp',
    answer_rejection_modal_text: 'Gửi lại ghi chú',
    answer_rejection_modal_content: 'Câu trả lời của {companyName} sẽ được gửi lại. \nHãy viết ghi chú về lý do gửi lại',
    answer_rejection_dialog_content: 'Câu trả lời của {companyName} đã được gửi lại',
    answer_rejection_button_title: 'Gửi lại',
  },
}
